import React from 'react'
import { Styling } from './styled.js'
import parse from 'html-react-parser'
import {GatsbyImage,  getImage} from 'gatsby-plugin-image';
import {CgClose} from 'react-icons/cg'
import closeOffPageHide from '../../../utils/closeOffPageHide'

export default function BrandsOffscreen({activeBrand, currentProduct}) {
    let image 
    let focalPoint

    console.log('activeBrand', activeBrand, currentProduct)

    if(activeBrand?.brand?.brandsBathImage?.bathImage?.localFile && currentProduct === 'Baths'){
        image = activeBrand?.brand?.brandsBathImage?.bathImage?.localFile
        focalPoint = activeBrand?.brand?.brandsBathImageFocalPoint?.brandsBathImageFocalPoint
        console.log('1')
    }
    else if(activeBrand?.brand?.brandsBathroomFurnitureImage?.bathroomFurnitureImage?.localFile && currentProduct === 'Bathroom furniture'){
        image = activeBrand?.brand?.brandsBathroomFurnitureImage?.bathroomFurnitureImage?.localFile
        focalPoint = activeBrand?.brand?.brandsBathroomFurnitureImageFocalPoint?.brandsBathroomFurnitureImageFocalPoint
        console.log('2')
        
    }
    else if(activeBrand?.brand?.brandsBathroomTapsImage?.bathroomTapsImage?.localFile && currentProduct === 'Brassware'){
        image = activeBrand?.brand?.brandsBathroomTapsImage?.bathroomTapsImage?.localFile
        focalPoint = activeBrand?.brand?.brandsBathroomTapsImageFocalPoint?.brandsBathroomTapsImageFocalPoint
        console.log('3')
    }
    else if(activeBrand?.brand?.brandsBathroomTilesImage?.bathroomTilesImage?.localFile && currentProduct === 'Bathroom tiles'){
        image = activeBrand?.brand?.brandsBathroomTilesImage?.bathroomTilesImage?.localFile
        focalPoint = activeBrand?.brand?.brandsBathroomTilesImageFocalPoint?.brandsBathroomTilesImageFocalPoint
        console.log('4')
    }
    else if(activeBrand?.brand?.brandsRadiatorsImage?.radiatorsImage?.localFile && currentProduct === 'Radiators'){
        image = activeBrand?.brand?.brandsRadiatorsImage?.radiatorsImage?.localFile
        focalPoint = activeBrand?.brand?.brandsRadiatorsImageFocalPoint?.brandsRadiatorsImageFocalPoint
        console.log('5')
    }
    else if(activeBrand?.brand?.brandsSanitaryWareImage?.sanitaryWareImage?.localFile && currentProduct === 'Sanitary ware'){
        image = activeBrand?.brand?.brandsSanitaryWareImage?.sanitaryWareImage?.localFile
        focalPoint = activeBrand?.brand?.brandsSanitaryWareImageFocalPoint?.brandsSanitaryWareImageFocalPoint
        console.log('6')
    }
    else if(activeBrand?.brand?.brandsShowersImage?.showersImage?.localFile && currentProduct === 'Showers'){
        image = activeBrand?.brand?.brandsShowersImage?.showersImage?.localFile
        focalPoint = activeBrand?.brand?.brandsShowersImageFocalPoint?.brandsShowersImageFocalPoint
        console.log('7')
    }
    else if(activeBrand?.brand?.brandsWetRoomImage?.wetRoomImage?.localFile && currentProduct === 'Wet room'){
        image = activeBrand?.brand?.brandsWetRoomImage?.wetRoomImage?.localFile
        focalPoint = activeBrand?.brand?.brandsWetRoomsImageFocalPoint?.brandsWetRoomsImageFocalPoint
        console.log('8')
    }
    else if(activeBrand?.brand?.brandsAccessoriesImage?.accessoriesImage?.localFile && currentProduct === 'Accessories'){
        image = activeBrand?.brand?.brandsAccessoriesImage?.accessoriesImage?.localFile
        focalPoint = activeBrand?.brand?.brandsAccessoriesImageFocalPoint?.brandsAccessoriesImageFocalPoint
        console.log('8')
    }
    else{
        image = activeBrand?.brand?.brandsFields?.mainImage?.localFile 
        focalPoint = activeBrand?.brand?.brandsFields?.mainImageFocalPoint
        console.log('9')
    }

    console.log(focalPoint)

    const theImage = getImage(image)
    const logo = getImage(activeBrand?.brand?.brandsFields?.logo?.localFile)
    return (
        <Styling className='brandsOffscreenWrapper'>
            <div className="brand brand-offscreen">
                <div className="close" onClick={(e) =>  closeOffPageHide(e)}>CLOSE</div>
                <div className="image-wrapper-outer">
                    <div className="logo-wrapper">
                        <GatsbyImage objectFit="contain"  image={logo} className="image" alt={'test'} />
                    </div>
                    <div className={`image-wrapper ${focalPoint}`}>
                        <GatsbyImage  image={theImage} className="image" alt={'test'} />
                    </div>
                </div>
                <div className="content-wrapper">
                    <div className="title minerva x_large">{activeBrand?.brand?.title}</div>
                    <div className="text">{activeBrand?.brand?.brandsFields?.description ? parse(activeBrand?.brand?.brandsFields?.description) : ''}</div>
                </div>
            </div>
        </Styling>
    )
}
